import { useSearch } from "@tanstack/react-router";
import { ConversionPixelForm } from "components/Forms/ConversionPixelForm/ConversionPixelForm.tsx";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { DrawerId } from "types/models.ts";

type ConversionType = "initiation" | "lead" | "prospect" | "sale" | "custom";

const DRAWER_TYPE_PARAM = `${DrawerId.ManageConversionPixel}-type` as const;

interface SearchParams {
    [DRAWER_TYPE_PARAM]?: ConversionType;
}

const isConversionType = (value: unknown): value is ConversionType =>
    value === "initiation" || value === "lead" || value === "prospect" || value === "sale" || value === "custom";

export const ManageConversionPixelDrawer = () => {
    const { t: tTable } = usePaldockTranslation("tables.conversion-pixels");
    const id = DrawerId.ManageConversionPixel;

    const searchParams = useSearch({ strict: false }) as SearchParams;
    const rawType = searchParams[DRAWER_TYPE_PARAM];
    const conversionType = isConversionType(rawType) ? rawType : undefined;

    const getTypeName = (type: ConversionType | undefined) => {
        if (!type) return "";
        return tTable(`types.${type}`);
    };

    return (
        <Drawer
            drawerId={id}
            title={<DrawerTitle mainTitle={getTypeName(conversionType)} />}
            searchParamsToClean={[DRAWER_TYPE_PARAM]}
        >
            {conversionType && <ConversionPixelForm conversionType={conversionType} />}
        </Drawer>
    );
};
